import React from 'react';

import { OpenFieldSection } from '../../../datasets/instances/store';
import { CalculatorCell, CalculatorField, Checkbox, CurrencyAmountField, DateField, DocumentField, Dropdown, LabelField, LongText, Number, PartySelect, Text, Time, WYSIWYGField } from '../../../datasets/fields';
import { DatasetFieldType, SingleDatasetField } from '../../../datasets/store';
import { newCalculatorField } from '../../../shared/calculator/constants';
import { ReportDatasetField } from './form-definition/fields/ReportDatasetField';
import styles from './ReportDefinitions.module.scss';

export const getReportFormDatasetField = (
    field: SingleDatasetField,
    datasetId: number,
    fieldOpen: boolean,
    parents: number,
    toggleSection: (fieldSection: OpenFieldSection) => void,
    getSectionOpen: (fieldSection: OpenFieldSection) => boolean,
    sectionId: string,
    groupIndex?: number,
    fieldHidden?: boolean,
    hiddenDocumentNameIds?: number[] | undefined
) => {
    const { id, type, settings } = field;
    const { showGracePeriod, showOutputField, documentProperty, datasetLinked, labelContent, includeFreeTextOption, calculatorFieldType } = settings;
    const defaultProps = { id: id!, disabled: true, value: '', index: 0, groupIndex, datasetId, parentFieldId: '', sectionId };
    switch (type) {
        case DatasetFieldType.TEXT:
            return <Text {...defaultProps} />;
        case DatasetFieldType.LONGTEXT:
            return <LongText {...defaultProps} />;
        case DatasetFieldType.DATE:
            return <DateField {...defaultProps} value={null} />;
        case DatasetFieldType.DROPDOWN:
        case DatasetFieldType.LINKFIELD:
            return <Dropdown {...defaultProps} value={null} type={type} listId='0' />;
        case DatasetFieldType.PARTY:
            return <PartySelect {...defaultProps} value={null} />;
        case DatasetFieldType.DOCUMENT:
            return <DocumentField id={id!} documentProperty={documentProperty || null} />;
        case DatasetFieldType.NUMBER:
            return <Number {...defaultProps} />;
        case DatasetFieldType.CHECKBOX:
            return <Checkbox {...defaultProps} checked={false} />;
        case DatasetFieldType.DATASET:
            return <ReportDatasetField
                id={id!}
                childDatasetId={datasetLinked!}
                fieldOpen={fieldOpen}
                parents={parents}
                fieldHidden={fieldHidden!}
                parentHiddenDocumentNameIds={hiddenDocumentNameIds}
            />;
        case DatasetFieldType.TIME:
            return <Time {...defaultProps} value={['', '']} />;
        case DatasetFieldType.WYSIWYG:
            return <WYSIWYGField {...defaultProps} value={null} fieldOpen={fieldOpen} toolbarHidden={true} toggleSection={toggleSection} getSectionOpen={getSectionOpen} />;
        case DatasetFieldType.LABEL:
            return <LabelField value={labelContent!} />;
        case DatasetFieldType.CALCULATOR:
            return <CalculatorField
                {...defaultProps}
                value={[newCalculatorField()]}
                fieldType={calculatorFieldType!}
                showOutputField={showOutputField!}
                showGracePeriod={showGracePeriod!}
                includeFreeTextOption={includeFreeTextOption}
                fieldOpen={fieldOpen}
            />;
        case DatasetFieldType.CURRENCY_AMOUNT:
            return <CurrencyAmountField
                {...defaultProps}
                currencyValue={{ currency: null, value: undefined }}
            />;
        default:
            return <div className={styles.unknownFieldType}>Field type unknown.</div>;
    }
};

export const getReportTableDatasetField = (
    field: SingleDatasetField,
    index: number,
    datasetId: number,
    toggleSection: (fieldSection: OpenFieldSection) => void,
    getSectionOpen: (fieldSection: OpenFieldSection) => boolean
) => {
    const { id, type, settings } = field;
    const { dropdownLinked, isMultiSelect, entityType, showGracePeriod, showOutputField, isCollapsible, includeFreeTextOption, calculatorFieldType, documentProperty } = settings;
    const defaultProps = { id: id!, value: '', index, disabled: true, isTable: true, parentFieldId: '', datasetId };
    switch (type) {
        case DatasetFieldType.TEXT:
            return <Text {...defaultProps} />;
        case DatasetFieldType.LONGTEXT:
            return <LongText {...defaultProps} />;
        case DatasetFieldType.DATE:
            return <DateField {...defaultProps} value={null} />;
        case DatasetFieldType.DROPDOWN:
        case DatasetFieldType.LINKFIELD:
            return <Dropdown
                {...defaultProps}
                value={null}
                type={type}
                listId={dropdownLinked!}
                isMulti={isMultiSelect}
                entityType={entityType}
                menuPortalTarget={document.body}
            />;
        case DatasetFieldType.PARTY:
            return <PartySelect
                {...defaultProps}
                value={null}
                menuPortalTarget={document.body}
            />;
        case DatasetFieldType.DOCUMENT:
            return <DocumentField {...defaultProps} id={id!} documentProperty={documentProperty || null} showClause />;
        case DatasetFieldType.NUMBER:
            return <Number {...defaultProps} />;
        case DatasetFieldType.CHECKBOX:
            return <Checkbox {...defaultProps} checked={false} />;
        case DatasetFieldType.TIME:
            return <Time {...defaultProps} value={['']} />;
        case DatasetFieldType.WYSIWYG:
            return <WYSIWYGField
                {...defaultProps}
                value={null}
                isCollapsible={isCollapsible}
                toolbarHidden
                datasetId={datasetId}
                toggleSection={toggleSection}
                getSectionOpen={getSectionOpen}
            />;
        case DatasetFieldType.CALCULATOR:
            return <CalculatorCell
                {...defaultProps}
                value={[newCalculatorField()]}
                fieldType={calculatorFieldType!}
                datasetId={datasetId}
                showOutputField={showOutputField!}
                showGracePeriod={showGracePeriod!}
                includeFreeTextOption={includeFreeTextOption}
            />;
        case DatasetFieldType.DATASET:
            return <div className={styles.nestedTableDatasetType}>Multiple tables cannot be added to single report right now</div>;
        default:
            return <div className={styles.unknownFieldType}>Field type unknown.</div>;
    }
};
